module.exports = __webpack_public_path__ + "img/img3.790f7be0.jpg";